import React from 'react';
import { connect } from 'react-redux';

type RethinkModeProps = {
  inRethink: boolean | undefined;
  display?: boolean;
  children: React.ReactNode;
};

function RethinkMode({ inRethink, display = false, children }: RethinkModeProps) {
  if (inRethink && display || !inRethink) {
    return (
      <>
        {children}
      </>
    );
  }

  return null;
}

const mapStateToProps = ({ ui: { inRethink } }) => ({ inRethink });
export default connect(mapStateToProps)(RethinkMode);
